import FollowUpRule from './FollowUpRule';
import SurveyQuestion from './SurveyQuestion';
import SurveyQuestionType from './SurveyQuestionType';

class SurveyQuestionText extends SurveyQuestion {
  value: string;

  constructor(
    questionId: string,
    questionType: SurveyQuestionType,
    title: string,
    description: string,
    group: string,
    variability: string,
    identifier: string,
    value: string,
    followUpRules: FollowUpRule[],
    imageIdentifier: string,
    info?: string,
    suffix?: string,
    allowSkipWithDefaultValue?: boolean
  ) {
    super(
      questionId,
      questionType,
      title,
      description,
      group,
      variability,
      identifier,
      followUpRules,
      imageIdentifier,
      info,
      suffix,
      allowSkipWithDefaultValue
    );

    this.value = value;
  }

  public static parse(object: any) {
    return new SurveyQuestionText(
      object.QuestionId,
      object.QuestionType,
      object.Title,
      object.Description,
      object.Group,
      object.Variability,
      object.Identifier,
      object.Value,
      object.FollowUpRules.map((rule: {}) => FollowUpRule.parse(rule)) ?? [],
      object.ImageIdentifier,
      object.Info ?? undefined,
      object.Suffix ?? undefined,
      object.AllowSkipWithDefaultValue ?? undefined
    );
  }
}

export default SurveyQuestionText;
